export default "https://kr-a.kakaopagecdn.com/web/qa/5.5.0-rc.0/static/comment/icon-best-red-f77914e3d495d23eecc3aa6174e60fc9.svg";